export const ID_CHECKLIST = {
    CSM_BOLTRACK: 'd66d1f32-5221-48fa-993d-be72cf4d812f',
    CSM_ISA: '3d535287-c33f-4fc8-9931-eced8591dddf',
};